import webhookUiSchema from './webhook/uiSchema'

const schemas: any = {
  webhook: {
    ui: webhookUiSchema,
  },
}

export default schemas
